import { render } from "./App.vue?vue&type=template&id=375c4bef"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=375c4bef&lang=scss"

import exportComponent from "/Applications/projects/bas-taj-korak-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__